import { useEffect, useState } from 'react';
import { isServer } from 'legacyfrontend/helpers/ssr-helper';

/**
 * SSR liviano en rutas de buscador vacías: el servidor renderiza solo SEO;
 * el contenido interactivo monta post-hidratación cuando window.__SSR_DEFER_SEARCH_SHELL__.
 */
export function useSearchShellClientReady(hasValidSearchParams) {
  const [ready, setReady] = useState(() => {
    if (isServer) {
      return hasValidSearchParams;
    }
    if (typeof window !== 'undefined' && window.__SSR_DEFER_SEARCH_SHELL__) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    setReady(true);
  }, []);

  return ready;
}
